import React from "react";

import "./NotFound.scss";

const NotFound = () => {
  return (
    <div className="page not-found-page">
      <h1>404</h1>
      <h3>Page not found</h3>
    </div>
  );
};

export default NotFound;
